import { ConditionalLinkProps } from "./ConditionalLink.types";
import { Link } from "react-router-dom";

const ConditionalLink = ({ condition, children, style, className, ...linkProps }: ConditionalLinkProps): JSX.Element =>
    condition ? (
        <Link style={{ ...style, display: "flex" }} className={className} {...linkProps}>
            {children}
        </Link>
    ) : (
        <span style={{ ...style, display: "flex" }} className={className}>
            {children}
        </span>
    );

export default ConditionalLink;
